import { render, staticRenderFns } from "./SelectUploadPlatform.vue?vue&type=template&id=943a7e32&scoped=true&"
import script from "./SelectUploadPlatform.vue?vue&type=script&lang=js&"
export * from "./SelectUploadPlatform.vue?vue&type=script&lang=js&"
import style0 from "./SelectUploadPlatform.vue?vue&type=style&index=0&id=943a7e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943a7e32",
  null
  
)

export default component.exports